import i18n from "@/i18n";

// Phase31: SPORT_LABELS now resolves via i18n at access time. Components
// that did `SPORT_LABELS[w.sport]` keep working — every property access
// hits the Proxy `get` trap and goes through t("sport.<sport>"). Updates
// to i18n.language flow through automatically because the next render
// re-reads the same property and re-calls t().
export const SPORT_LABELS: Record<string, string> = new Proxy({} as Record<string, string>, {
  get(_target, prop: string): string {
    if (typeof prop !== "string") return "";
    const fallback = {
      swim: "Swim",
      bike: "Bike",
      run: "Run",
      brick: "Brick",
      strength: "Strength",
      mobility: "Mobility",
      rest: "Rest",
    }[prop] ?? prop;
    return i18n.t(`sport.${prop}`, { defaultValue: fallback }) as string;
  },
});

export const SPORT_EMOJI_FREE: Record<string, string> = {
  swim: "S",
  bike: "B",
  run: "R",
  brick: "BR",
  strength: "ST",
  mobility: "M",
  rest: "—",
};

// Phase31: minute/hour units pulled from i18n so durations read in the
// active language. Components don't change — same fmtDuration(min) call.
export function fmtDuration(minutes: number): string {
  const minU = i18n.t("duration.min", { defaultValue: "min" }) as string;
  const hU = i18n.t("duration.h", { defaultValue: "h" }) as string;
  const hShort = i18n.t("duration.h_short", { defaultValue: "h" }) as string;
  const mShort = i18n.t("duration.m_short", { defaultValue: "m" }) as string;
  if (minutes < 60) return `${minutes} ${minU}`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h} ${hU}` : `${h}${hShort} ${m}${mShort}`;
}

export function secToPace(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}:${s.toString().padStart(2, "0")}`;
}
